enum GlobalTopics {
  ALL = 'all',
  UNCATEGORIZED = 'uncategorized',
}

export default GlobalTopics;
